import React from "react";



const Main = ({ username, userRole }) => {

    return (

        <div className="page-content stylish-dashboard">
            <div className="container-fluid">
                <center>
                    <div className="profile-foreground position-relative mx-n4 mt-n4 banner-background">
                        <div className="fade-down-overlay"></div>
                        <img
                            src="assets/images/dbc-london1.jpg"
                            alt="Background"
                            className="hero-background-image"
                        />
                    </div>

                    <div className="pt-5 mb-4 welcome-section fade-in-text">
                        <h1 className="welcome-title">Welcome, {username}!</h1>
                        <p className="welcome-subtitle">We're glad to have you back ✨</p>
                    </div>
                </center>

                <div className="row justify-content-center">
                    <div className="col-lg-10 fade-in-card">
                        <div className="glass-card shadow-lg">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6 col-md-4">
                                        <div className="d-flex mt-4 text-white">
                                            <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                    <i className="ri-user-2-fill"></i>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1 overflow-hidden">
                                                <p className="mb-1 text-black bold">Designation :</p>
                                                <h6 className="text-truncate mb-0">{userRole}</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-6 col-md-4">
                                        <div className="d-flex mt-4 text-white">
                                            <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                                                <div className="avatar-title bg-light rounded-circle fs-16 text-primary">
                                                    <i className="ri-global-line"></i>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1 overflow-hidden">
                                                <p className="mb-1 text-black bold">Website :</p>
                                                <h6 className="text-truncate mb-0">www.designbuildcast.co.uk</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div> {/* End row */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )

}

export default Main;